var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { CalendarMapper, CalendarRequestMapper } from './calendar.mapper';
import * as i0 from "@angular/core";
import * as i1 from "@gh/core-data";
var SupplierCalendarRestService = /** @class */ (function (_super) {
    __extends(SupplierCalendarRestService, _super);
    function SupplierCalendarRestService(settings) {
        var _this = _super.call(this, settings) || this;
        _this.settings = settings;
        return _this;
    }
    SupplierCalendarRestService.prototype.getAll = function (request) {
        return this.httpPut("/calendar", request, CalendarRequestMapper, arrayOf(CalendarMapper));
    };
    SupplierCalendarRestService.ɵfac = function SupplierCalendarRestService_Factory(t) { return new (t || SupplierCalendarRestService)(i0.ɵɵinject(i1.RestSettings)); };
    SupplierCalendarRestService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierCalendarRestService, factory: SupplierCalendarRestService.ɵfac });
    return SupplierCalendarRestService;
}(AbstractRestService));
export { SupplierCalendarRestService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierCalendarRestService, [{
        type: Injectable
    }], function () { return [{ type: i1.RestSettings }]; }, null); })();
